export enum MusicChannelGroupType {
    RADIO = "radio",
    SEARCH = "search",
    JINGLE = "jingle"
}